import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import O from './components/O';
// import P from './components/P';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import Q from './components/Q';
import R from './components/R';
import Rooftop from './components/Rooftop';
import S from './components/S';
import SolarEnergySolutions from './components/SolarEnergySolutions';
import TaxCredit from './components/TaxCredit';
import WholeHome from './components/WholeHome';
import USC from './components/UsPage/C'

export default function IndexDynamic() {
    const { useState, useRouter, useLang, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);
    const { locale } = useRouter();
    const { t } = useLang('costsaving');
    const isUs = ['us'].includes(locale);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#cost-saving-C' },
            { text: t('secC_btn2'), link: '#cost-saving-E' },
            // { text: t('secC_btn3'), link: '#cost-saving-J' },
            // { text: t('secC_btn4'), link: '#cost-saving-L' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {isUs && (
                <>
                    <SolarEnergySolutions />
                    <Rooftop />
                    <WholeHome />
                    <F />
                    <C />
                    <D />
                    <TaxCredit />
                    <R />
                </>
            )}
            {!isUs && (
                <>
                    <B />
                    <C />
                    <D />
                    <E />
                    <F />
                    {['us', 'ca'].includes(locale) && <ProductInlineBanner />}
                    {locale !== 'ca' && <G />}
                    {locale === 'ca' && <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.CostSaving} entry_position={7} />}
                    <H />
                    <O />
                    {/* <P /> */}
                    {!['us', 'ca'].includes(locale) && <Q />}
                    <R />
                    <S />
                </>
            )}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
